import {useFlags} from "@atlaskit/flag";

export function useAnankeFlags() {
    return useFlags();
}
